export default "__VITE_ASSET__B2dNFHbs__"